import styled from 'styled-components';
import indents from '@bankiru/ui-kit/constants/indents.json';
import colors from '@bankiru/ui-kit/constants/colors.json';

export const LinkWrapper = styled.div`
	border-bottom: 1px solid ${colors.minorGrayLighten};
	padding: ${indents.indentS};
`;
